import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import UserBadge from "~/modules/user/components/UserBadge";

import { GaiaExpandableMapMarkerBodyFieldworkerProfileFragment } from "./fragments.generated";

type GaiaExpandableMapMarkerFieldworkerBodyProfileProps = {
    fieldworker: GaiaExpandableMapMarkerBodyFieldworkerProfileFragment;
};

export function GaiaExpandableMapMarkerFieldworkerBodyProfile({
    fieldworker,
}: GaiaExpandableMapMarkerFieldworkerBodyProfileProps) {
    const { t } = useTranslation("plannerV2");

    return (
        <Stack padding={1} gap={1} direction="row" alignItems="center" sx={{ maxWidth: 250, cursor: "default" }}>
            <UserBadge profilePicture={fieldworker.user.profilePictureMedia?.url} />
            <Stack>
                <Typography variant="subtitle1" fontWeight="bold">
                    {fieldworker.user.firstName} {fieldworker.user.lastName}
                </Typography>
                <Typography variant="caption">
                    {t("gaiaExpandableMapMarkerFieldworker.maxShiftsPerWeek")}: {fieldworker.maxShiftsPerWeek}
                </Typography>
            </Stack>
        </Stack>
    );
}
